import { DataGridErrorState } from '../../common/DataGrid/DataGridErrorState';

interface TargetsTableErrorStateProps {
  message?: string;
}

export function TargetsTableErrorState({
  message = 'There was an error loading the targets. Please, try again later.',
}: TargetsTableErrorStateProps) {
  return <DataGridErrorState colSpan={5}>{message}</DataGridErrorState>;
}
